module.exports = __webpack_public_path__ + "img/title.1be56f16.png";